import { render } from "./UIContent.vue?vue&type=template&id=b9b4a214&scoped=true"
import script from "./UIContent.vue?vue&type=script&lang=js"
export * from "./UIContent.vue?vue&type=script&lang=js"

import "./UIContent.vue?vue&type=style&index=0&id=b9b4a214&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b4a214"]])

export default __exports__